import { render, staticRenderFns } from "./FormPeriod.vue?vue&type=template&id=2ced2ff6&"
import script from "./FormPeriod.vue?vue&type=script&lang=js&"
export * from "./FormPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports